/* eslint-disable no-param-reassign */

import { ASSETS_IMAGE_THUMBS_PATH, DELIVERY_FEE_SKU, PACKAGE_WRAPPING_FEE_SKU } from '@/utils/constants';

import productApi from '@/apis/product';

export default {
    namespaced: true,
    state: () => ({
        groupTypes: [{
                name: '비타민·무기질·유산균',
                groupCode: 'V/M',
            },
            {
                name: '기능성',
                groupCode: 'F',
            },
        ],
        productsFetched: false,
        products: [],
        productsAll: [],
    }),
    mutations: {
        init(state, payload) {
            state.products = payload.products;
            state.productsAll = payload.productsAll;
            state.productsFetched = true;
        },
    },
    actions: {
        async init({ commit }) {
            console.log('store::product/init');
            const r = await productApi.getAllProducts();
            const refinedProducts = r.map((n) => {
                if (n.category == 'P') {
                    if (n.item_sku == PACKAGE_WRAPPING_FEE_SKU) {
                        return {
                            item_name: '포장비',
                            item_sku: n.item_sku,
                            img_url: `${ASSETS_IMAGE_THUMBS_PATH}/missing.jpg`,
                            outlink: '',
                            price: n.price,
                            seq: 10001
                        }
                    } else if (n.item_sku == DELIVERY_FEE_SKU) {
                        return {
                            item_name: '배송비',
                            item_sku: n.item_sku,
                            img_url: `${ASSETS_IMAGE_THUMBS_PATH}/missing.jpg`,
                            outlink: '',
                            price: n.price,
                            seq: 10002
                        }
                    }
                } else {
                    return {
                        seq: n.seq,
                        bv: n.bv,
                        category: n.category,
                        explain: n.explain,
                        item_name: n.item_name,
                        item_sku: n.item_sku,
                        max_tab: n.max_tab,
                        min_tab: n.min_tab,
                        img_url: `${ASSETS_IMAGE_THUMBS_PATH}/${n.item_sku}.jpg`,
                        outlink: `https://${process.env.SSO_HOST}/p/${n.item_sku}/mpn`,
                        price: n.price,
                        pv: n.pv,
                        recm_tab: n.recm_tab,
                        display: n.display,
                    }
                }
            });

            console.log('store::product/productAll');
            const r2 = await productApi.getAllProductsIncludeUseN();
            const refinedProductsIncludeUseN = r2.map((n) => {
                if (n.category == 'P') {
                    if (n.item_sku == PACKAGE_WRAPPING_FEE_SKU) {
                        return {
                            item_name: '포장비',
                            item_sku: n.item_sku,
                            img_url: `${ASSETS_IMAGE_THUMBS_PATH}/missing.jpg`,
                            outlink: '',
                            price: n.price,
                            seq: 10001
                        }
                    } else if (n.item_sku == DELIVERY_FEE_SKU) {
                        return {
                            item_name: '배송비',
                            item_sku: n.item_sku,
                            img_url: `${ASSETS_IMAGE_THUMBS_PATH}/missing.jpg`,
                            outlink: '',
                            price: n.price,
                            seq: 10002
                        }
                    }
                } else {
                    return {
                        seq: n.seq,
                        bv: n.bv,
                        category: n.category,
                        explain: n.explain,
                        item_name: n.item_name,
                        item_sku: n.item_sku,
                        max_tab: n.max_tab,
                        min_tab: n.min_tab,
                        img_url: `${ASSETS_IMAGE_THUMBS_PATH}/${n.item_sku}.jpg`,
                        outlink: `https://${process.env.SSO_HOST}/p/${n.item_sku}/mpn`,
                        price: n.price,
                        pv: n.pv,
                        recm_tab: n.recm_tab,
                        display: n.display,
                    }
                }
            });

            // 포장비
            // refinedProducts.push({
            //   item_name: '포장비',
            //   item_sku: PACKAGE_WRAPPING_FEE_SKU,
            //   img_url: `${ASSETS_IMAGE_THUMBS_PATH}/missing.jpg`,
            //   outlink: '',
            //   price: 50,
            //   seq: 10001,
            // });

            // 포장비
            // refinedProducts.push({
            //   item_name: '배송비',
            //   item_sku: DELIVERY_FEE_SKU,
            //   img_url: `${ASSETS_IMAGE_THUMBS_PATH}/missing.jpg`,
            //   outlink: '',
            //   price: 3300,
            //   seq: 10002,
            // });

            commit('init', { products: refinedProducts, productsAll: refinedProductsIncludeUseN });
        },
    },
    getters: {
        productsFetched: (state) => state.productsFetched,
        groupTypes: (state) => state.groupTypes,
        products: (state) => state.products,
        productsAll: (state) => state.productsAll,
        productsGroupByCategory: (state) => {
            const productsGroup = {};
            state.products.forEach((n) => {
                const { category } = n;
                if (!productsGroup[category]) {
                    productsGroup[category] = [];
                }
                productsGroup[category].push(n);
            });

            return productsGroup;
        },
    },
};